//
//  ElementPropertyValue.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class ElementPropertyValue {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        this.id = model.id;
        this.designSystemVersionId = model.designSystemVersionId;
        if (Object.hasOwn(model, "value")) {
            this.value = model.value;
        }
        else {
            // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'string | nu... Remove this comment to see the full error message
            this.value = null;
        }
        this.definitionId = model.definitionId;
        this.targetElementId = model.targetElementId;
    }
}
